import { useActions } from '@core/store'
import { useSessionLogout } from '@features/session'
import { authTypeStore } from '../store/authTypeStore'

export const useLogout = () => {
    const logoutSession = useSessionLogout()
    const { setAuthType } = useActions({ setAuthType: authTypeStore.actions.setAuthType })

    const logout = () => {
        logoutSession()
        setAuthType(null)
    }

    return { logout }
}
